export const BASE_URL = process.env.REACT_APP_BASE_URL;

//NODE_ENV === 'development' ? "http://localhost/survey/backend/" : 'https://survey.ivyis.org/backend/';